import { render } from "./ModalNuovaAnagrafica.vue?vue&type=template&id=742008f0&scoped=true"
import script from "./ModalNuovaAnagrafica.vue?vue&type=script&lang=js"
export * from "./ModalNuovaAnagrafica.vue?vue&type=script&lang=js"

import "./ModalNuovaAnagrafica.vue?vue&type=style&index=0&id=742008f0&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_jecko_1768814729495645082/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742008f0"]])

export default __exports__